import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font,
  Image as PDFImage
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    padding: 10,
    paddingTop: '13%',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  text: {
    fontSize: 10
  },
  textUnderlined: {
    fontSize: 10,
    textDecoration: 'underline',
    textDecorationColor: 'black',
    textDecorationThickness: 1.5,
    width: '120%'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderRadius: '5px',
    border: '1px solid black',
    width: '100%',
    gap: 120,
    paddingTop: '5px',
    paddingBottom: '3px',
    paddingRight: '40px',
    paddingLeft: '40px',
    position: 'relative'
  },
  column: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  column1: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height:"68%",
    marginRight:"72%",
    gap:15,
    marginTop:"1%",
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 1,
    width: '100%'
  },
  label: {
    fontWeight: 'bold',
    fontSize: 10
  },
  value: {
    fontSize: 10,
    fontWeight: 'normal',
    width: '65%'
  },
  leftColumn: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: 0
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const PatientRegistrationPdf22 = ({ data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const ageString = data.age;
  const years = ageString.match(/\d+Y/);

  const addDaysToDate = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };

  const validityDate = addDaysToDate(data.op_date, 4);

  const formatRegTime = (time) => {
    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    
    // Format to 12-hour time
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    return date.toLocaleTimeString('en-US', options);
  }

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${data.name} Registration`} style={{ border: '3px solid black' }}>
          <Page size="A4" style={styles.page}>
          <View
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0, // Ensures the image stays behind the content
            marginTop:"3%"
          }}
        >
          <PDFImage
            src="/PDF Print Format.png"
            style={{
              width: '100%',
              height: '100%',
              
             // Adjust opacity if needed to make the content more readable
            }}
          />
        </View>
            <View
              style={{
                border: '1px solid black',
                paddingBottom: '2px',
                paddingLeft: '50px',
                paddingRight: '50px',
                marginBottom: 3,
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.9)' 
              }}
            >
              <Text
                content="OPD Case Paper"
                style={{
                  ...styles.label,
                  fontFamily: 'Roboto',
                  fontSize: '15px'
                }}
              />
            </View>

            <View style={{ ...styles.contentContainer, border: '1px solid black' }}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text
                    content="UHID                     :             "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text
                    content={data.uhid}
                    style={{
                      ...styles.value,
                      textAlign: 'start',
                      paddingBottom: '2px'
                    }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Patient Name      :           " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.name}
                    style={{
                      ...styles.value,
                      textAlign: 'start',
                      paddingBottom: '2px'
                    }}
                  />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Gender                 :            "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text
                    content={data.gender}
                    style={{
                      ...styles.value,
                      textAlign: 'start',
                      paddingBottom: '2px'
                    }}
                  />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Age                       :            "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text
                    content={data.age}
                    style={{
                      ...styles.value,
                      textAlign: 'start',
                      paddingBottom: '2px'
                    }}
                  />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Phone No            :            "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text
                    content={data.mobile}
                    style={{
                      ...styles.value,
                      textAlign: 'start',
                      paddingBottom: '2px'
                    }}
                  />
                </View>
                <View style={{ ...styles.row,width:"135%" }}>
                  <Text
                    content="Address              :      "
                    style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                  />
                  <Text content={`${data.address}`} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={{...styles.row,width:"135%"}}>
                  <Text
                    content="Consultant          :"
                    style={{ ...styles.label, fontFamily: 'Roboto'}}
                  />
                  <Text
                    content={`${data.consultant}(${data?.doctor_qualification})`}
                    style={{
                      ...styles.value,
                      textAlign: 'start',
                      paddingBottom: '2px'
                    }}
                  />
                </View>
              </View>

              <View style={styles.column}>
                <View style={styles.row}>
                  <Text
                    content="Reg Date              :            "
                    style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                  />
                  <Text
                    content={`${formatDate(data.first_reg_date)}`}
                    style={{
                      ...styles.value,
                      textAlign: 'start',
                      paddingBottom: '2px'
                    }}
                  />
                </View>
                <View style={{ ...styles.row }}>
                  <Text
                    content="Visit Type            :              "
                    style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                  />
                  <Text
                    content={`${data.opd_type}`}
                    style={{ ...styles.value, textAlign: 'start', paddingBottom: '2px' }}
                  />
                </View>
                <View style={{ ...styles.row }}>
                  <Text
                    content="Visit  No               :             "
                    style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                  />
                  <Text
                    content={`${data.visit_no}`}
                    style={{ ...styles.value, textAlign: 'start', paddingBottom: '2px' }}
                  />
                </View>
                <View style={{ ...styles.row }}>
                  <Text
                    content="Visit Date             :            "
                    style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                  />
                  <Text
                    content={`${formatDate(data.reg_date)} ${formatRegTime(data.reg_time)} `}
                    style={{ ...styles.value, textAlign: 'start', paddingBottom: '2px' }}
                  />
                </View>
                <View style={{ ...styles.row,width:"135%" }}>
                  <Text
                    content="Department         :    "
                    style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                  />
                  <Text
                    content={`${data.department}`}
                    style={{ ...styles.value, textAlign: 'start', paddingBottom: '2px' }}
                  />
                </View>

                <View style={{ ...styles.row }}>
                  <Text
                    content="Entitlement          :           "
                    style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                  />
                  <Text
                    content={`${data.ref_by}`}
                    style={{ ...styles.value, textAlign: 'start', paddingBottom: '2px' }}
                  />
                </View>
                <View style={{ ...styles.row }}>
                  <Text
                    content="Total Paid             :           "
                    style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                  />
                  <Text content={`${data?.total}`} style={{ ...styles.value, textAlign: 'start', paddingBottom: '2px' }} />
                </View>
              </View>
            </View>
            <View
              style={{
                width: '100%',
                borderBottom: '1px solid black',
                alignItems: 'center', 
                justifyContent: 'space-between', 
                height: '4%',
                flexDirection: 'row', 
                paddingHorizontal: '3%'
              }}
            >
              <Text
                style={{
                  fontFamily: 'Roboto',
                  textAlign: 'left' 
                }}
                content="Date"
               />
              <Text
                style={{
                  fontFamily: 'Roboto',
                  textAlign: 'center', 
                  flex: 1 
                }}
                content="Examination/Medication"
              />
            </View>
            <View style={{ ...styles.column1, borderRight: '1px solid black', width: '23%' }}>
              <Text content="BP" style={{ fontFamily: 'Roboto'}} />
              <Text content="Pulse" style={{ fontFamily: 'Roboto' }} />
              <Text content="SPO2" style={{ fontFamily: 'Roboto' }} />
              <Text content="TEMP" style={{ fontFamily: 'Roboto' }} />
              <Text content="WEIGHT" style={{ fontFamily: 'Roboto' }} />
              <Text content="INVESTIGATION" style={{ fontFamily: 'Roboto',marginTop:"10%",textDecoration:"underline" }} />
              <Text content="CBC" style={{ fontFamily: 'Roboto' }} />
              <Text content="Blood Group" style={{ fontFamily: 'Roboto' }} />
              <Text content="LFT" style={{ fontFamily: 'Roboto' }} />
              <Text content="Urea/Creat" style={{ fontFamily: 'Roboto' }} />
              <Text content="HIV/HCV/HBsAg" style={{ fontFamily: 'Roboto' }} />
              <Text content="ECG" style={{ fontFamily: 'Roboto' }} />
              <Text content="X-Ray" style={{ fontFamily: 'Roboto' }} />
            </View>
            <View
              style={{
                width: '100%',
                borderBottom: '1px solid black',
                alignItems: 'center', 
                justifyContent: 'space-between', 
                height: '4%',
                flexDirection: 'row', 
                paddingHorizontal: '3%'
              }}
            >
              <Text
                style={{
                  fontFamily: 'Roboto',
                  textAlign: 'left' 
                }}
                content={`Validity : 1 Consultation(s) before ${formatDate(validityDate)}`}
               />
            </View>
          </Page>
          
        </Document>
      </PDFViewer>
    </div>
  );
};
